export function getRectDirectedCycle(width: number, height: number): { x: number; y: number }[] {
    const rectDirectedCycle: { x: number; y: number }[] = [];

    // 上边
    for (let i = 0; i <= width; i++) {
        rectDirectedCycle.push({ x: i, y: 0 });
    }

    // 右边
    for (let i = 0; i <= height; i++) {
        rectDirectedCycle.push({ x: width, y: i });
    }

    // 下边
    for (let i = width; i >= 0; i--) {
        rectDirectedCycle.push({ x: i, y: height });
    }

    // 左边
    for (let i = height; i >= 0; i--) {
        rectDirectedCycle.push({ x: 0, y: i });
    }

    return rectDirectedCycle;
}
